import React, { useState } from "react";

import { Autocomplete } from "@material-ui/lab";
import { CircularProgress, TextField } from "@material-ui/core";

import _ from "lodash";

import { useQuery } from "@apollo/react-hooks";
import { loader } from "graphql.macro";

const COMPANIES = loader("./graphql/CompanyList.gql");

export default ({ projectId, ...props }) => {
  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState([]);

  const { loading } = useQuery(COMPANIES, {
    skip: !open && !projectId,
    variables: {
      where: {
        pair: projectId
          ? {
              project_id: {
                _eq: projectId,
              },
            }
          : {},
      },
      order_by: [{ company_name: "asc" }],
    },
    onCompleted(data) {
      setOptions(_.get(data, "companies") || []);
    },
  });

  return (
    <Autocomplete
      {...props}
      open={open}
      onOpen={() => {
        setOpen(true);
      }}
      onClose={() => {
        setOpen(false);
      }}
      options={options.sort(
        (a, b) =>
          -(b.dlt_company_name || b.company_name)[0]
            .toUpperCase()
            .localeCompare(
              (a.dlt_company_name || a.company_name)[0].toUpperCase()
            )
      )}
      groupBy={(option) => option.company_name[0].toUpperCase()}
      getOptionSelected={(option, value) =>
        option.company_id === value.company_id
      }
      getOptionLabel={(option) =>
        option.dlt_company_name || option.company_name
      }
      loading={loading}
      renderInput={(params) => (
        <TextField
          {...params}
          label="บริษัท"
          variant="outlined"
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <React.Fragment>
                {loading ? (
                  <CircularProgress color="inherit" size={20} />
                ) : null}
                {params.InputProps.endAdornment}
              </React.Fragment>
            ),
          }}
        />
      )}
    />
  );
};
